module.exports = __webpack_public_path__ + "img/smartphone.9174e70e.svg";